<p-card class="dashBoard">
  <table class="header">
    <td><div class="title" (click)="showPortfolios()">Clients</div></td>
    <td><button class="btn-medium-primary right action" (click)="showCreatePortfolio()">Create a portfolio</button></td>
  </table>
  @if (!(loadedUnassigned && loadedPfPending && loadedTax)) {
    <div class='loading-spinner'></div>
  }
  @if (loadedUnassigned && loadedPfPending && loadedTax) {
    <div>
      <div class="section"></div>
      <irb-panel-button [label]="'Unassigned Accounts'" [isTall]="true" (click)="showUnassignedAccounts()"><span class="count">{{data.unassignedAccountCount}} / ${{data.unassignedAccountValue | number}}</span></irb-panel-button>
      <irb-panel-button [label]="'Portfolios with pending rebalance results'" [isTall]="true" (click)="showPortfoliosWithPendingResults()"><span class="count">{{data.portPendingResultsCount | number}}</span></irb-panel-button>
      <irb-panel-button [label]="'30 day tax harvest expiration (last 7 days)'" [isTall]="true" (click)="showTaxHarvestExpiration()"><span class="count">{{data.taxHarExpCount | number}}</span></irb-panel-button>
    </div>
  }
</p-card>
